import { render, staticRenderFns } from "./VideosList.vue?vue&type=template&id=7dcdb2c8"
import script from "./VideosList.vue?vue&type=script&lang=js"
export * from "./VideosList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports